import { useTranslation } from 'react-i18next';

import { Wrapper, TitleWrapper, DescriptionWrapper } from './ContentSearchemptyPage.styles';

export const ContentSearchEmptyPage = () => {
  const { t } = useTranslation('ManagerBaseContentTranslations');

  return (
    <Wrapper>
      <TitleWrapper>{t('NO_RESULTS_FOUND')}</TitleWrapper>
      <DescriptionWrapper>{t('NO_RESULTS_FOUND_DESCRIPTION')}</DescriptionWrapper>
    </Wrapper>
  );
};
